import './table.style.scss';
import React from 'react';
import { ConfigProvider, Table as AntdTable, TableProps } from 'antd';
import fa_IR from 'antd/locale/fa_IR';
import { Empty } from '../empty/empty.index';

export const Table = <T extends object>(props: TableProps<T>) => {    return (
        <ConfigProvider
            locale={fa_IR}
            theme={{
                components: {
                    Table: {
                        headerBg: '#FFFFFF',
                        borderColor: '#D2DEFE',
                    },
                },
            }}
            renderEmpty={Empty}
        >
            <AntdTable
                className={`border border-primary-20 ${props.className ? props.className : ''}`}
                bordered={false}
                pagination={{
                    ...props.pagination,
                    style: {direction: 'ltr', backgroundColor: 'white', margin: 0, padding: '16px 0'},
                    position: ['bottomCenter']
                }}
                {...props}
            />
        </ConfigProvider>
    );
};